module.exports = __webpack_public_path__ + "static/media/CCNL-2020.f98e38f5.pdf";